const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: 'none!important'
  }),
  table: {
    padding: '4px 0px 4px 0px'
  },
  dark: {
    color: 'blue',
  },
  testInfo:{
    margin:0,
    marginTop: 10,
    marginBottom: 15,
    '& h3': {
      fontSize: '0.8rem'
    }
  },
  cometTestInfo:{
    margin:0,
    marginTop: 10,
    marginBottom: 2,
    '& h3': {
      fontSize: '0.8rem'
    }
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/views/summaryv2/styles.js